import { render, staticRenderFns } from "./discussion_filter.vue.js?vue&type=template&id=7c3f3040!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./discussion_filter.vue?vue&type=template&id=7c3f3040"
import script from "./discussion_filter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./discussion_filter.vue?vue&type=script&lang=js"
export * from "./discussion_filter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./discussion_filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports